// @todo we might not need this anymore, it's really old

const OTHelpers = require('../common-js-helpers/OTHelpers.js');

// Returns a String representing the supported WebRTC crypto scheme. The possible
// values are SDES_SRTP, DTLS_SRTP, and NONE;
//
// Broadly:
// * Firefox only supports DTLS
// * Older versions of Chrome (<= 24) only support SDES
// * Newer versions of Chrome (>= 25) support DTLS and SDES
//
module.exports = function supportedCryptoScheme() {
  const chromeBefore25 = (
    OTHelpers.env.name === 'Chrome' &&
    OTHelpers.env.version < 25
  );

  return (chromeBefore25 ? 'SDES_SRTP' : 'DTLS_SRTP');
};
